import { To } from 'react-router-dom';
import { isEmpty } from 'lodash';
import queryString from 'query-string';

import { URLQuery } from '@app/constants';

interface PushParams {
  pathname: string;
  query?: URLQuery;
}

interface RouteParams {
  ({ pathname, query }: PushParams): To;
}

export const generateRouteParams: RouteParams = ({ pathname, query }) => ({
  pathname,
  ...(query &&
    !isEmpty(query) && {
      search: `?${queryString.stringify(query)}`,
    }),
});
